import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _types$SET_CART_SUCCE;

import * as types from './types';
export default (_types$SET_CART_SUCCE = {}, _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_SUCCESS, function (state, payload) {
  var currentState = state;
  currentState.success = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_SUCCESS_SERVER, function (state, payload) {
  var currentState = state;
  currentState.successServer = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART, function (state, payload) {
  var currentState = state;
  currentState.items = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_QTY, function (state, payload) {
  var currentState = state;
  currentState.total = payload;
}), _defineProperty(_types$SET_CART_SUCCE, types.SET_CART_STATE, function (state, payload) {
  var currentState = state;
  currentState.cartState = payload;
}), _types$SET_CART_SUCCE);